import Fingerprint2 from 'fingerprintjs2'
import UAParser from 'ua-parser-js'
import { log } from './LogHelper'
import _ from 'lodash'

export const GetDeviceFingerPrint = async () => {
  try {
    let components = await Fingerprint2.getPromise({
      preprocessor: function (key, value) {
        if (key === 'userAgent') {
          var parser = new UAParser(value) // https://github.com/faisalman/ua-parser-js
          var userAgentMinusVersion = parser.getOS().name + ' ' + parser.getBrowser().name
          return userAgentMinusVersion
        }
        return value
      },
      excludes: {
        screenResolution: true,
        deviceMemory: true,
        webdriver: true,
        addBehavior: true,
        openDatabase: true,
        adBlock: true,
        hasLiedLanguages: true,
        hasLiedResolution: true,
        enumerateDevices: true,
        hasLiedOs: true,
        hasLiedBrowser: true,
        plugins: true
      }
    })
    const values = components.map((component) => { return component.value })
    const id = Fingerprint2.x64hash128(values.join(''), 31)
    const userAgent = _.filter(components, { key: 'userAgent' })[0].value
    const timeZone = _.filter(components, { key: 'timezone' })[0].value
    log.Trace('Calculate Device Finger Print', { Id: id, Values: components })
    return { Id: id, UserAgent: userAgent, TimeZone: timeZone }
  } catch (err) {
    log.Trace('Calculate Device Finger Print Error', { Error: err })
    return 'FFFFFFFFFFF'
  }
}
